var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$store.state.accessToken)?_c('MainComponent'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }